import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServicesHeroBanner from "../components/ServicesHeroBanner";
import MultpleCard from "../components/Multple-card";
import ServicesProcess from "../components/ServicesProcess";
import Choose from "../components/Choose";
import ContactForm from "../components/contact-form";
import Blog from "../components/Blog";

import servicesHeaderImage from "../images/comp/services-header-image-6.webp";
import diverseImage from "../images/comp/choose_cloud_img.webp";
import researchIcon from "../images/research-icon.png";
import planningIcon from "../images/Planning.png";
import designIcon from "../images/Design.png";
import ux_icon from "../images/ux_icon.png";
import supportIcon from "../images/Support.png";
import developmentIcon from "../images/development.png";
import qualityIcon from "../images/Quality.png";
import testingIcon from "../images/Testing.png";

const CloudsolutionsPage = () => {
  const heroBannerData = {
    subtitle: "Cloud Solutions",
    title: "Cloud That Scales. Cloud That Performs.",
    description:
      "At Hope Web Solutions, we offer scalable, secure, and cost-effective cloud solutions that empower businesses to operate smarter, faster, and more efficiently. From cloud migration to infrastructure setup, we help you harness the full potential of the cloud with custom strategies tailored to your goals.",
    buttonText: "Contact now",
    buttonLink: "#contact",
    img: servicesHeaderImage,
  };
  const cardsData = [
    {
      title: "Cloud Infrastructure Setup",
      description:
        "Designing and deploying scalable cloud environments using AWS, Google Cloud, Microsoft Azure, and more.",
      icon: researchIcon,
    },
    {
      title: "Cloud Migration Services",
      description:
        "Smoothly moving your applications, data, and workloads to the cloud for improved performance, scalability, and cost savings.",
      icon: planningIcon,
    },
    {
      title: "Cloud Application Development",
      description:
        "Building cloud-native applications with modern frameworks and architectures for optimal performance and scalability.",
      icon: designIcon,
    },
    {
      title: "DevOps & Automation",
      description:
        "Implementing DevOps practices to streamline development, testing, and deployment processes for faster time-to-market.",
      icon: developmentIcon,
    },
    {
      title: "Hybrid & Multi-Cloud Solutions",
      description:
        "Designing flexible solutions that use multiple cloud platforms or combine on-premise and cloud infrastructure.",
      icon: testingIcon,
    },
    {
      title: "Cloud Security & Backup",
      description:
        "Setting up robust cloud security measures, data encryption, and automated backup solutions to protect your data.",
      icon: qualityIcon,
    },
  ];

  const processData = [
    {
      title: "Requirement Analysis",
      description:
        "Understanding your current infrastructure, challenges, and cloud readiness.",
      icon: researchIcon,
    },
    {
      title: "Cloud Strategy Planning",
      description:
        "Recommending the best-fit cloud model (public, private, hybrid) and services for your business.",
      icon: designIcon,
    },
    {
      title: "Architecture Design",
      description:
        "Creating a scalable, secure, and cost-efficient cloud architecture.",
      icon: ux_icon,
    },
    {
      title: "Deployment & Migration",
      description:
        "Setting up cloud services and migrating apps, data, and servers with minimal downtime.",
      icon: developmentIcon,
    },
    {
      title: "Security Implementation",
      description:
        "Enforcing firewalls, encryption, identity access, and compliance measures.",
      icon: testingIcon,
    },
    {
      title: "Monitoring & Optimization",
      description:
        "Continuous monitoring, performance tuning, and cost optimization to keep your cloud infrastructure efficient.",
      icon: supportIcon,
    },
  ];

  const chooseData = {
    title: "Why Choose Hope Web Solutions?",
    image: diverseImage,
    imageAlt: "Team",
    items: [
      {
        label: "Planning",
        text: "Hope Web Solutions is a leading Web and Mobile App Development company, delivering cutting-edge digital solutions.",
      },
      {
        label: "Our Mission",
        text: "Our mission is to empower businesses with exceptional digital solutions that drive growth, enhance user experience.",
      },
      {
        label: "Our Vision",
        text: "Our vision is to be a global leader in web and mobile app development, recognized for our innovation, quality, and customer satisfaction.",
      },
    ],
    buttonText: "Contact now",
    buttonLink: "/contact",
  };
  return (
    <div>
      <Header />
      <ServicesHeroBanner {...heroBannerData} />
      <section className="planning-section-services">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8 mb-4 mb-lg-0 position-relative text-center">
              <h2 className="title">Cloud Solutions Services</h2>
              <p className="sub-title text-black pt-2">
                We deliver comprehensive cloud services that enhance
                flexibility, reduce IT costs, and support your business growth.
              </p>
            </div>
          </div>
          <div className="process-grid mt-3">
            {/* 👉 Cards Loop */}
            {cardsData.map((item, index) => (
              <MultpleCard
                key={index}
                title={item.title}
                description={item.description}
                icon={item.icon}
              />
            ))}
          </div>
        </div>
      </section>
      <ServicesProcess
        title="Cloud Solutions Process"
        subtitle="Our streamlined process ensures your cloud journey is efficient, reliable, and aligned with your business objectives."
        processData={processData}
      />
      <Choose {...chooseData} />
      <ContactForm />
      <Blog />
      <Footer />
    </div>
  );
};

export default CloudsolutionsPage;
